import React from 'react';
import styled, { keyframes } from 'styled-components';
import DropDown from 'react-dropdown';
import '../../assets/fonts/fonts.css';

import SliderModal from '../appComponents/SliderModal';
import PaymentRadio from '../appComponents/PaymentRadio';
import Slider from '../appComponents/Slider';

/* global tw */

const FilterInner = styled.div`
    ${tw`relative flex flex-wrap items-start px-6 py-4 pb-10 max-h-full w-full overflow-y-scroll`};
    -webkit-overflow-scrolling: touch;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
`

const FilterTopRow = styled.div`
    ${tw`flex w-full justify-between items-center mb-4`};
`

const FilterTitle = styled.h3`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 0.6875rem;
    font-weight: 700;
    color: #CB53D1;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    margin: 0;
`

const CloseBtn = styled.p`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
    color: #5A5A6E;
    cursor: pointer;
    transition: color 0.15s ease;
    margin: 0;
    &:hover { color: #F5F5F7; }
`

const FilterHeading = styled.h3`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #F5F5F7;
    letter-spacing: -0.03em;
    margin: 0 0 1.25rem 0;
    &::after {
        content: '';
        display: block;
        margin-top: 0.625rem;
        height: 2px;
        width: 2rem;
        background: linear-gradient(90deg, #AA0BCA, #5500DB);
        border-radius: 2px;
    }
`

const FilterGroup = styled.div`
    ${tw`block p-2`};
    min-width: 120px;
`

const FilterGroupLabel = styled.label`
    display: block;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 0.6875rem;
    font-weight: 700;
    color: #CB53D1;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 0.625rem;
`

const OptionLabel = styled.span`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 1rem;
    font-weight: 500;
    color: #9898A8;
    display: block;
    margin-left: 0.5rem;
    transition: color 0.15s ease;
`

const FilterRow = styled.div`
    ${tw`flex w-full flex-wrap justify-between mb-12`};
`

const BudgetSection = styled.div`
    ${tw`w-full`};
    margin-top: 1rem;
`

const BudgetLabel = styled.label`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 0.6875rem;
    font-weight: 700;
    color: #CB53D1;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    display: block;
    margin-bottom: 0.75rem;
`

const DropdownWrapper = styled.div`
    ${tw`w-full mt-4`};
    .Dropdown-root { font-family: 'Plus Jakarta Sans', 'Inter', sans-serif; }
    .Dropdown-control {
        background: #111118;
        border: 1px solid rgba(170,11,202,0.25);
        color: #9898A8;
        border-radius: 6px;
        padding: 0.625rem 0.875rem;
        cursor: pointer;
        transition: all 0.18s ease;
        &:hover { border-color: rgba(170,11,202,0.5); }
    }
    .Dropdown-menu {
        background: #1A1A24;
        border: 1px solid rgba(170,11,202,0.2);
        border-radius: 6px;
        overflow: hidden;
    }
    .Dropdown-option {
        color: #9898A8;
        padding: 0.5rem 0.875rem;
        font-size: 0.9375rem;
        transition: background 0.15s ease;
        &:hover {
            background: rgba(170,11,202,0.1);
            color: #F5F5F7;
        }
    }
    .Dropdown-option.is-selected {
        background: rgba(170,11,202,0.12);
        color: #F5F5F7;
    }
    .Dropdown-arrow { border-top-color: #9898A8; }
`

const Filter = (props) => {
    return (
        <SliderModal active={props.active} filter filterClick={props.filterClick}>
            <FilterInner>
                <FilterTopRow>
                    <FilterTitle>Filters</FilterTitle>
                    <CloseBtn onClick={props.onCloseClick}>Close</CloseBtn>
                </FilterTopRow>

                <FilterHeading>Filter by</FilterHeading>

                <FilterRow>
                    <FilterGroup>
                        <FilterGroupLabel>Vehicle</FilterGroupLabel>
                        <PaymentRadio value='all' onClick={props.vehicleAllClick} active={props.vehicleAllActive}>
                            <OptionLabel>All</OptionLabel>
                        </PaymentRadio>
                        <PaymentRadio value='MINI' onClick={props.vehicleMiniClick} active={props.vehicleMiniActive}>
                            <OptionLabel>Mini</OptionLabel>
                        </PaymentRadio>
                        <PaymentRadio value='SEDAN' onClick={props.vehicleSedanClick} active={props.vehicleSedanActive}>
                            <OptionLabel>Sedan</OptionLabel>
                        </PaymentRadio>
                        <PaymentRadio value='SUV' onClick={props.vehicleSuvClick} active={props.vehicleSuvActive}>
                            <OptionLabel>SUV</OptionLabel>
                        </PaymentRadio>
                    </FilterGroup>

                    {props.rentalChoiceTwo && (
                        <FilterGroup>
                            <FilterGroupLabel>Fuel Type</FilterGroupLabel>
                            <PaymentRadio value='both' onClick={props.fuelBothClick} active={props.fuelBothActive}>
                                <OptionLabel>All</OptionLabel>
                            </PaymentRadio>
                            <PaymentRadio value='Petrol' onClick={props.fuelPetrolClick} active={props.fuelPetrolActive}>
                                <OptionLabel>Petrol</OptionLabel>
                            </PaymentRadio>
                            <PaymentRadio value='Diesel' onClick={props.fuelDieselClick} active={props.fuelDieselActive}>
                                <OptionLabel>Diesel</OptionLabel>
                            </PaymentRadio>
                            <PaymentRadio value='Ev' onClick={props.fuelEvClick} active={props.fuelEvActive}>
                                <OptionLabel>EV</OptionLabel>
                            </PaymentRadio>
                        </FilterGroup>
                    )}

                    {props.rentalChoiceTwo && (
                        <FilterGroup>
                            <FilterGroupLabel>Transmission</FilterGroupLabel>
                            <PaymentRadio value='both' onClick={props.transmissionBothClick} active={props.transmissionBothActive}>
                                <OptionLabel>Both</OptionLabel>
                            </PaymentRadio>
                            <PaymentRadio value='Manual' onClick={props.transmissionManualClick} active={props.transmissionManualActive}>
                                <OptionLabel>Manual</OptionLabel>
                            </PaymentRadio>
                            <PaymentRadio value='Automatic' onClick={props.transmissionAutoClick} active={props.transmissionAutoActive}>
                                <OptionLabel>Automatic</OptionLabel>
                            </PaymentRadio>
                        </FilterGroup>
                    )}

                    {props.rentalChoiceTwo && (
                        <FilterGroup>
                            <FilterGroupLabel>Kilometers</FilterGroupLabel>
                            <PaymentRadio value='both' onClick={props.kilometersBothClick} active={props.kilometersBothActive}>
                                <OptionLabel>Both</OptionLabel>
                            </PaymentRadio>
                            <PaymentRadio value='unlimited' onClick={props.kilometersUnlimitedClick} active={props.kilometersUnlimitedActive}>
                                <OptionLabel>Unlimited</OptionLabel>
                            </PaymentRadio>
                            <PaymentRadio value='limited' onClick={props.kilometersLimitedClick} active={props.kilometersLimitedActive}>
                                <OptionLabel>Limited</OptionLabel>
                            </PaymentRadio>
                        </FilterGroup>
                    )}

                    {props.rentalChoiceTwo && (
                        <FilterGroup style={{ minWidth: '160px' }}>
                            <FilterGroupLabel>Brands</FilterGroupLabel>
                            <DropdownWrapper>
                                <DropDown
                                    options={props.brandsList}
                                    value={props.brandLabel === 'clear' ? 'Select a Brand' : props.brandLabel}
                                    onChange={(event) => { props.brandSelected(event); }}
                                    placeholder="Select a Brand"
                                />
                            </DropdownWrapper>
                        </FilterGroup>
                    )}

                    <BudgetSection>
                        <BudgetLabel>Budget</BudgetLabel>
                        <div style={{ padding: '0 1rem' }}>
                            <Slider budgetValues={(event) => { props.budgetFilter(event) }} minAmt={props.minBudgetAmt} maxAmt={props.maxBudgetAmt} />
                        </div>
                    </BudgetSection>
                </FilterRow>
            </FilterInner>
        </SliderModal>
    );
}

export default Filter;
